import(/* webpackMode: "eager" */ "/codebuild/output/src3102719317/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/page.tsx");
